import css from 'styled-jsx/css';

export default css`.home-search-bar-container {
    background-color: #fff;
    .common-page-container {
        background-color: #fff;
    }
}
.home-search-bar-container-fixed {
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    padding-top: 10px; // 搜索框上面留白悬停时少了10px，避免突然塌陷的抖动
}

`